module.exports = __webpack_public_path__ + "static/img/level-3-4.af8dcb90.png";